import { authApi } from '../../utils/api';

export const adminMuayenelerPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Muayene Takibi</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addMuayeneBtn">+ Yeni Muayene Kaydı</button>
                    </div>
                </div>

                <div id="muayeneModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 id="muayeneModalTitle">Yeni Muayene Kaydı</h2>
                            <button class="modal-close" id="closeMuayeneModal">&times;</button>
                        </div>
                        <form id="muayeneForm" class="modal-form">
                            <input type="hidden" id="muayeneId">
                            <div class="form-group">
                                <label for="muayeneRuhsatId">Araç (Ruhsat) *</label>
                                <select id="muayeneRuhsatId" class="form-control" required>
                                    <option value="">Araç Seçin</option>
                                </select>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="muayeneTarihi">Muayene Tarihi *</label>
                                    <input type="date" id="muayeneTarihi" class="form-control" required>
                                </div>
                                <div class="form-group">
                                    <label for="sonrakiMuayene">Sonraki Muayene *</label>
                                    <input type="date" id="sonrakiMuayene" class="form-control" required>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="muayeneSonuc">Sonuç</label>
                                <select id="muayeneSonuc" class="form-control">
                                    <option value="beklemede">Beklemede</option>
                                    <option value="gecti">Geçti</option>
                                    <option value="kaldi">Kaldı</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="muayeneNotlar">Notlar</label>
                                <textarea id="muayeneNotlar" class="form-control" rows="2"></textarea>
                            </div>
                            <div id="muayeneFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelMuayeneBtn">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="muayenelerList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
